module.exports = __webpack_public_path__ + "img/logo-white.77c34e44.svg";